import React, { useState, useEffect } from "react";
import plusWhite from "../../../assets/images/plus-white.svg";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../../styles/style.css";
import "../../../styles/payout.css";
import "../../../styles/upi-mandate.css";
import { TabPanel, Tabs } from "react-tabs";
import trashIcon from "../../../assets/images/trash-03.svg";
import editIcon from "../../../assets/images/edit_btn.svg";
import Modal from "react-bootstrap/Modal";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { Loader } from "../../../components/loader";
import {
  assignQuestionsToContest,
  contestByCategoryList,
  deleteContest,
  fetchElligibleList,
  fetchModuleDetails,
  fetchParticipantList,
  fetchWinners,
  postWinner,
} from "../../../action/contest";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import showNotification from "../../../components/notification/showNotification";
import { AsyncPaginate } from "react-select-async-paginate";
const ContestList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { moduleId } = useParams();
  const [categoryList, setCategoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isListLoading, setIsListLoading] = useState(true);
  const [isWinnerSelected, setIsWinnerSelected] = useState(true);
  const [openDeleteModel, setIsOpenDeleteModel] = useState(false);
  const [openWinnerModel, setOpenWinnerModel] = useState(false);
  const [viewWinnerModel, setViewWinnerModel] = useState(false);
  const [questionbank, setQuestionBank] = useState(false);
  const [contestId, setContestId] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [list, setList] = useState([]);
  const [moduleCategoryId, setModuleCategoryId] = useState("");
  const [Winerlist, setWinerList] = useState([]);
  const [elligiblelist, setelligibleList] = useState([]);
  const [partTab, setpartTab] = useState(1);
  const [quesList, setQuesList] = useState([]);
  const [questionId, setQuestionId] = useState();
  const [selectedQues, setSelectedQues] = useState();
  const [selectedValue, setSelectedValue] = useState([]);
  const [menuOpen, setMenuOpen] = useState(true);
  // const [loadOptions, setLoadOptions] = useState([]);
  console.log("selctes", selectedValue.length);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  // Function to fetch paginated options
  const loadOptions = async (search, prevOptions) => {
    console.log("load option");
    if (!hasMore) return { options: [], hasMore: false };

    try {
      const response = await contestByCategoryList(
        moduleCategoryId,
        page,
        pageSize,
        moduleId
      );
      if (response.status) {
        const newOptions = response?.data.map((item) => ({
          value: item._id,
          label: item.title.en,
        }));

        const allOptions = [...prevOptions, ...newOptions];

        // Check if more data is available
        setHasMore(response.data.length === pageSize);
        setPage((prev) => prev + 1);
        setQuesList(allOptions);

        return {
          options: newOptions,
          hasMore: response.data.length === pageSize,
        };
      }
    } catch (error) {
      console.error("Failed to fetch options", error);
    }

    return { options: [], hasMore: false };
  };

  //   setLoadOptions(
  //     quesList.map((item) => ({
  //       value: item?._id,
  //       label: item?.title?.en, // 'label' should be lowercase
  //     }))
  //   );
  // };
  const getCategoryPage = async () => {
    try {
      setIsLoading(true);
      const response = await fetchModuleDetails(moduleId); // Adjust 10 to the desired number of items per page
      if (response.status) {
        setCategoryList(response.data[0]?.contests);
        setIsWinnerSelected(response.data[0]?.winnersSelected);
        setModuleCategoryId(response?.data[0]?.moduleCategoryId);
        if (response.data[0].winnersSelected) {
          getWinners();
        } else {
          getUsers();
        }
        setIsLoading(false);
      }
    } catch (error) {
      console?.error("Failed to fetch category data", error);
    }
  };
  const assignQuestion = async () => {
    // const data = {
    //   moduleCategoryId: moduleCategoryId,
    //   contestId: moduleId,
    //   moduleId:  selectedValue
    // }
    const questions = selectedValue.map((item) => ({
      moduleCategoryId: moduleCategoryId,
      moduleId: moduleId,
      contestId: item.value,
    }));
    const data = { questions };

    try {
      setIsLoading(true);
      const response = await assignQuestionsToContest(data); // Adjust 10 to the desired number of items per page
      if (response.status) {
        setQuestionId("");
        setSelectedQues("");
        setQuestionBank(false);
        getCategoryPage();
        showNotification("Success", response.message, "success");
        setSelectedValue([]);
        setPage(1);
      } else {
        showNotification("Error", response.message, "danger");
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
    setSelectedValue([]);
    setPage(1);
  };
  // const FreeContestList = async () => {
  //   try {
  //     // setIsLoading(true);
  //     const response = await contestByCategoryList(moduleCategoryId, pageNo, pageSize); // Adjust 10 to the desired number of items per page
  //     if (response.status) {
  //       setQuesList(response?.data);
  //       setTotalData(response?.data?.count);
  //       // setIsLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch category data", error);
  //   }
  // };
  const getUsers = async () => {
    try {
      setIsListLoading(true);
      const response = await fetchParticipantList(moduleId);
      if (response.status) {
        if (response.data) {
          setList(response.data?.users);
        }
        setIsListLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };
  const getEligible = async () => {
    try {
      setIsListLoading(true);
      const response = await fetchElligibleList(moduleId);
      if (response.status) {
        if (response.data) {
          setelligibleList(response.data);
        }
        setIsListLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const selectWinners = async () => {
    try {
      setIsListLoading(true);
      const response = await postWinner(moduleId);
      if (response.status) {
        setList(response?.data);
        setIsListLoading(false);
        getWinners();
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const getWinners = async () => {
    try {
      setIsListLoading(true);
      const response = await fetchWinners(moduleId);
      if (response.status) {
        setWinerList(response?.data?.list);
        setIsListLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const handleDeleteContest = async () => {
    const payload = { moduleId };
    try {
      const response = await deleteContest(contestId, payload);
      if (response.status) {
        showNotification("Delete", "Question deleted Successfully!", "success");
        getCategoryPage();
        setIsOpenDeleteModel(false);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };
  useEffect(() => {
    getCategoryPage();
    getEligible();
    getWinners();
    getUsers();
  }, []);
  return isLoading ? (
    <Loader />
  ) : (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              <Breadcrumb
                paths={[
                  {
                    name: "Contest List",
                    link: `/contest/contest-list`,
                    state: location.state,
                  },
                  {
                    name: "Question",
                    link: "/contest/list",
                  },
                ]}
              />
            </div>
          </div>
          <div className="flex_btn">
            <button
              color="success"
              tag="a"
              onClick={() => {
                setShowModel(true);
              }}
              className="btn btn-success">
              Participants List
            </button>
            <button
              color="success"
              tag="a"
              onClick={() => {
                setQuestionBank(true);
                // FreeContestList();
                setHasMore(true);
                setSelectedValue([]);
                setPage(1);
                loadOptions();
              }}
              className="btn btn-success">
              Add question from library
            </button>
            <Link
              className="btn btn-info addbbtn"
              color="info"
              to={`/contest/add/${moduleId}`}
              state={location.state}>
              Add Question
              <img
                src={plusWhite}
                alt=""
                className="payout_down"
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="tab_box">
        <Tabs>
          <TabPanel>
            <div className="">
              <table className="payout_table upi-mandate_table">
                <thead>
                  <tr className="tableHead">
                    <th className="thHeader">
                      <div className="payoutHead hndIcon">Title</div>
                    </th>
                    <th className="thHeader">
                      <div className="payoutHead hndIcon">Options</div>
                    </th>

                    <th className="thHeader">
                      <div className="payoutHead hndIcon">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="15">
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {categoryList?.length > 0 ? (
                        categoryList?.map((item) => (
                          <tr key={item._id}>
                            <td>{item?.title?.en}</td>
                            <td>{item?.options?.length}</td>
                            <td className="flex_btn three_btn">
                              <Link
                                to={`/contest/edit/${item._id}`}
                                state={{
                                  pageno: location.state,
                                  id: moduleId,
                                }}>
                                <img
                                  src={editIcon}
                                  alt="editIcon"
                                />
                              </Link>
                              <img
                                src={trashIcon}
                                onClick={() => {
                                  setContestId(item?._id);
                                  setIsOpenDeleteModel(true);
                                }}
                                alt="trash"
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="15"
                            className="text_center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </TabPanel>
        </Tabs>
      </div>
      <Offcanvas
        show={questionbank}
        onHide={() => {
          setQuestionBank(false);
        }}
        placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h4>Question Library</h4>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* <div className="scroll_v mt-0" style={{ position: "relative" }}>
            <table className="payout_table upi-mandate_table" style={{ overflow: "unset", overflowX: "hidden" }}>
              <thead className="pos_Sticky">
                <tr className="tableHead" style={{ position: "sticky", top: "-1px" }} >
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">title</div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {quesList.map((item, i) => (
                  <tr className={selectedQues == i ? "QuesBg" : ""} key={i} style={{ cursor: "pointer" }} onClick={() => {
                    setQuestionId(item?._id);
                    setSelectedQues(i);
                  }}>
                    <td>{item?.title?.en}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="btn_container_btn questionFooterBtn">
            <div className="flex_btn mt-3 justify-content-end mb-3" >
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => {
                  setQuestionId("");
                  setSelectedQues("");
                  setQuestionBank(false);
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-success"
                type="button"
                onClick={() => {
                  assignQuestion();
                }}
              >
                Add question
              </button>
            </div>
          </div> */}
          <div className="selectQuestion_box">
            <AsyncPaginate
              value={selectedValue}
              loadOptions={loadOptions}
              onChange={setSelectedValue}
              placeholder="Select questions from the list below"
              isMulti={true}
              menuIsOpen={menuOpen} // Keep the menu open
              onMenuOpen={() => setMenuOpen(true)} // Keep it open when clicked
              onMenuClose={() => setMenuOpen(true)} // Prevent closing
              closeMenuOnSelect={false}
              additional={{ page: 1 }} // This keeps track of pagination
              styles={{
                menuList: (provided) => ({
                  ...provided,
                  height: "100%",
                  minHeight: "70vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  fontSize: "12px",
                }),
                dropdownIndicator: () => ({ display: "none" }), // Hide the arrow
                indicatorSeparator: () => ({ display: "none" }), // Hide separator line
              }}
            />
            <div className="btn_container_btn questionFooterBtn">
              <div className="flex_btn mt-3 justify-content-end mb-3 px-3">
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={() => {
                    setQuestionId("");
                    setSelectedQues("");
                    setQuestionBank(false);
                  }}>
                  Cancel
                </button>
                <button
                  className="btn btn-success"
                  type="button"
                  onClick={() => {
                    assignQuestion();
                  }}
                  disabled={selectedValue.length == 0}>
                  Add question
                </button>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas
        show={showModel}
        onHide={() => {
          setShowModel(false);
          setpartTab(1);
        }}
        placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {/* {isWinnerSelected ? "Winners" : "Participants"} */}
            {partTab == 2 ? (
              <>
                {elligiblelist?.length > 0 ? (
                  <>
                    {Winerlist?.length ? (
                      <button
                        color="info"
                        tag="a"
                        className="btn btn-primary"
                        onClick={() => {
                          // selectWinners();
                          setViewWinnerModel(true);
                        }}>
                        View Winners
                      </button>
                    ) : (
                      <button
                        color="info"
                        tag="a"
                        className="btn btn-primary"
                        onClick={() => {
                          // selectWinners();
                          setOpenWinnerModel(true);
                        }}>
                        Select Winners
                      </button>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="scroll_v">
            <div className="contest__tabs">
              <div
                className={`contest__tab ${partTab == 1 ? "active" : ""}`}
                onClick={() => {
                  setpartTab(1);
                }}>
                Participants List
              </div>
              <div
                className={`contest__tab ${partTab == 2 ? "active" : ""}`}
                onClick={() => {
                  setpartTab(2);
                }}>
                Eligible Users
              </div>
            </div>
            <table className="payout_table upi-mandate_table">
              <thead>
                <tr className="tableHead">
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Name</div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {isListLoading ? (
                  <tr>
                    <td colSpan="4">
                      <Loader />
                    </td>
                  </tr>
                ) : partTab == 1 ? (
                  <>
                    {list?.length > 0 ? (
                      list?.map((item) => (
                        <tr key={item?._id}>
                          <td>{item?.name}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="3"
                          className="text_center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </>
                ) : (
                  <>
                    {elligiblelist?.length > 0 ? (
                      elligiblelist.map((item, i) => (
                        <tr key={item?._id}>
                          <td>{item?.users?.name}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="3"
                          className="text_center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Modal
        show={openDeleteModel}
        onHide={() => {
          setIsOpenDeleteModel(false);
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete this question?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-dark"
            variant="secondary"
            onClick={() => {
              setIsOpenDeleteModel(false);
            }}>
            No
          </button>
          <button
            className="btn btn-success"
            variant="primary"
            onClick={handleDeleteContest}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={openWinnerModel}
        onHide={() => {
          setOpenWinnerModel(false);
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Select Winner</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to proceed ?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-dark"
            variant="secondary"
            onClick={() => {
              setOpenWinnerModel(false);
            }}>
            No
          </button>
          <button
            className="btn btn-success"
            variant="primary"
            onClick={() => {
              selectWinners();
              setOpenWinnerModel(false);
            }}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={viewWinnerModel}
        onHide={() => {
          setViewWinnerModel(false);
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Winner List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="winnersList">
            <table className="payout_table upi-mandate_table">
              <thead>
                <tr className="tableHead">
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Name</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Price</div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {isListLoading ? (
                  <tr>
                    <td colSpan="4">
                      <Loader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {Winerlist?.length > 0 ? (
                      Winerlist?.map((item) => {
                        return (
                          <tr
                            key={item?._id}
                            onClick={() => {
                              navigate(`/user/profile/${item?.userId}`);
                            }}>
                            <td>{item?.name}</td>
                            <td>Rs. {item?.price}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="3"
                          className="text_center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ContestList;
